import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import { Paper, Typography, makeStyles } from '@material-ui/core'

import summary from 'images/subscribe/summary.png'
import useSubscribe from 'hooks/useSubscribe'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const Item = ({ item }) => {
  const classes = useStyles()

  const price = React.useMemo(() => helpers.currency(item.price), [item.price])

  return (
    <div className={classes.itemContainer}>
      <Typography color="primary" className={classes.itemName}>
        {item.name}
      </Typography>
      <Typography color="textSecondary" className={classes.itemPrice}>
        {price}
      </Typography>
    </div>
  )
}

const Summary = ({ showPlans = false, ...rest }) => {
  const classes = useStyles()
  const subscribe = useSubscribe()

  const totalCart = React.useMemo(
    () => helpers.currency(subscribe.totalCart, { hideSymbol: true }),
    [subscribe.totalCart],
  )

  return (
    <Paper className={clsx(classes.root, rest.className)}>
      <img alt="Resumo" src={summary} className={classes.image} />

      {showPlans && (
        <div>
          <Typography
            variant="h4"
            color="textSecondary"
            align="center"
            className={classes.titlePlans}
          >
            Plano(s) contratados
          </Typography>

          {subscribe.cart.map((item, index) => (
            <Item item={item} key={`${item.id}${index}`} />
          ))}
        </div>
      )}

      <div className={classes.priceBox}>
        <Typography className={classes.price}>
          <Typography component="span" className={classes.pricePrefix}>
            R$
          </Typography>

          {totalCart}
        </Typography>
      </div>

      <Typography color="textSecondary" className={classes.message}>
        Total da sua primeira fatura
      </Typography>
    </Paper>
  )
}

Summary.propTypes = {
  showPlans: PropTypes.bool,
}

export default Summary
